import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import questionBankIcon from '../../assets/img/question_bank/question_icon_blue.svg';
import ComponentHeader from '../../common/ComponentHeader';
import CustomButton from '../../common/CustomButton';
import {
  isRevisionModeActive,
  onHandleTableSorting,
  renderHTMLContent,
} from '../../common/function';
import { messages } from '../../common/messages';
import FlashCard from '../../components/FlashCard';
import ValidateSaveReportIcon from '../../views/Common/ValidateSaveReportIcon';
import CustomCard from '../QuestionBank/CustomCard';
import CustomCardBody from '../QuestionBank/CustomCardBody';
import CustomCardHeader from '../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../QuestionBank/LoaderWrapper';
import ReportComponent from '../ReportComponent';
import GMATCalculator from '../../common/Calculator/GMATCalculator';
import TableSort from './TableSort';
import { EXAM_NAMES, QUESTION_TYPE, SUBSCRIPTION_STATUS } from '../../common/constant';
import { getUserSelectedChoices } from './utils/questionUtils';
import { tableAnalysisTwoPartConfig, twoStatementConfig } from './utils/questionConfigs';
import RatingComponent from '../RatingComponent';

export default class TwoStatement extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      selectedAnswer1: '',
      selectedAnswer2: '',
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      showCalculator: false,
      isError: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
    const { questionMode = EXAM_NAMES.GMAT_FOCUS } = this.props;
    this.isRevisionMode = isRevisionModeActive(questionMode);
  }
  async componentDidMount() {
    const {
      apiServices,
      params,
      questionType: question_type,
    } = this.props;
    const { readingid, subscription } = params;
    const payload = {
      reading_id: readingid,
      question_type,
      subscriptionstatus: +subscription ? SUBSCRIPTION_STATUS.PAID : SUBSCRIPTION_STATUS.FREE,
    };

    const response = await apiServices.fetchQuestionsReadingWise(payload);
    if (!response.success) return;

    let questions = response.result || [];

    const isSubscribed = !!+subscription;
    if (!isSubscribed) {
      questions = questions.filter((question) => +question.free === 1);
    }

    await this.handleSetCurrentQuestion(questions);
    this.setState({
      questionData: questions,
      isUserSubscribed: isSubscribed,
      isLoading: false,
    });
  }
  setUserSelectedChoices = (index, questions) => {
    const currentQuestion =
      questions && questions.length > 0 ? questions[index] : this.state.questionData[index];
    const { stateTableName = 'gmat_focus_question_stat' } = this.props;
    const attemptedStateDetails = (currentQuestion && currentQuestion[stateTableName]) || {};
    try {
      const { questionType: type } = this.props;

      const config =
        type === QUESTION_TYPE.TABLE_QUESTION ? tableAnalysisTwoPartConfig : twoStatementConfig;
      const { selectedOptions, extraState } = getUserSelectedChoices({
        question: currentQuestion,
        stat: attemptedStateDetails,
        config,
      });
      if (selectedOptions && Object.keys(selectedOptions).length > 0) {
        this.setState(
          {
            selectedOptions,
            ...selectedOptions,
            ...extraState,
          },
          () => {
            this.handleValidate(false);
          },
        );
      } else {
        this.setState({
          ...config.extractExtraState(selectedOptions),
          selectedOptions,
          ...selectedOptions,
        });
      }
    } catch (error) {
      console.error('Invalid JSON in selected_choice:', error);
    }
  };

  handleSetCurrentQuestion = async (questions) => {
    this.setState({ isLoading: true });
    const { question_id: questionId } = this.props.params;
    const index = questions.findIndex((question) => question.id === +questionId) || 0;
    const [questionText, tableContent] = questions[index > -1 ? index : 0].question.split('<table');
    const questionContent = questionText || questions[index > -1 ? index : 0].question;
    const questionTable = tableContent
      ? `<table id="myTable" border="1" cellpadding="5px" ${tableContent}`
      : '';
    const sortingOptions =
      (questions[index > -1 ? index : 0].sortBy &&
        questions[index > -1 ? index : 0].sortBy.split(',')) ||
      [];
    this.setState({
      currentIndex: index > -1 ? index : 0,
      currentQuestion: questions[index > -1 ? index : 0],
      questionContent,
      questionTable,
      sortingOptions,
      isLoading: false,
    });
    this.getSavedQuestion(questions[index > -1 ? index : 0].id);
    this.getQuestionRating(questions[index > -1 ? index : 0].id);

    if (this.isRevisionMode) {
      this.setUserSelectedChoices(index, questions);
    } else {
      this.resetStates();
    }
  };

  handleSaveQuestion = async () => {
    const { questionId, reading, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id,
      type,
      topic_name,
      reading_id,
    };

    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  getQuestionRating = async (question_id) => {
    const { apiServices, questionType: type } = this.props;
    const params = {
      question_id,
      type,
    };

    try {
      const response = await apiServices.fetchRating(params);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const questionRating = response.ratting[0].ratting;

        this.setState({
          questionRating,
          questionRatingTitle: messages.RATED,
        });
      }
    } catch (error) {
      console.error('error handling....', error);
    }
  };

  handleQuestionRating = async (item, nextValue, prevValue, name) => {
    const { questionId } = this.state;
    const question_id = item.id;
    const { apiServices, questionType: type } = this.props;

    try {
      // Only update if the rating changed
      if (prevValue !== nextValue) {
        const updatePayload = { question_id, ratting: nextValue, type };
        const updateRatingResponse = await apiServices.updateQuestionRating(updatePayload);

        if (updateRatingResponse.success) {
          this.setState({ questionRatingTitle: messages.RATED });
        }
      }

      this.setState({ rating: nextValue });

      // Check if a rating already exists
      const fetchPayload = { question_id, type };
      const response = await apiServices.fetchRating(fetchPayload);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const latestRating = response.ratting[0].ratting;
        this.setState({
          questionRating: latestRating,
          questionRatingTitle: `${messages.RATED}`,
        });
      } else {
        // Save a new rating
        const savePayload = {
          question_id,
          ratting: nextValue,
          type,
        };
        const saveRatingResponse = await apiServices.saveRating(savePayload);

        if (saveRatingResponse.success) {
          this.setState({
            questionRatingTitle: messages.RATED,
            questionRating: nextValue,
          });
        }
      }
    } catch (error) {
      console.error('Error in handleQuestionRating:', error);
    }
  };

  resetStates = () => {
    this.setState({
      validated: false,
      selectedAnswer1: '',
      selectedAnswer2: '',
      questionRating: 0,
      selectedOptions: {},
      isError: false,
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  redirectToNextPreviousQuestion = (index) => {
    const { questionData, isUserSubscribed } = this.state;
    const { handleChangeParams, params } = this.props;
    const { readingid, chapterid } = params;
    const currentQuestion = questionData[index];
    if (!currentQuestion) return;

    const { id, question, sortBy } = currentQuestion;

    handleChangeParams({ index, question_id: id });
    /**
     * Navigates to a specific question by index, updates component state with the selected question's
     * content and table (if present), and fetches saved question data and rating.
     *
     * Working:
     * - Splits the question text and table HTML to allow rendering a dropdown between them.
     * - Updates state with question content, table, and sorting options.
     * - Triggers fetch for saved question and rating.
     *
     * Unable to change:
     * - The split and state update logic must remain as is to support inserting a dropdown between the question and table.
     *
     * @param {number} index - The index of the question to navigate to.
     */
    const [questionText, tableContent] = question.split('<table');
    const questionContent = questionText || question;
    const questionTable = tableContent
      ? `<table id="myTable" border="1" cellpadding="5px" ${tableContent}`
      : '';
    this.setState({
      currentIndex: index,
      currentQuestion,
      questionContent,
      questionTable,
      sortingOptions: (sortBy && sortBy.split(',')) || [],
    });

    this.getSavedQuestion(id);
    this.getQuestionRating(id);
  };

  getPreviousQuestion = async () => {
    const { currentIndex} = this.state;
    if (currentIndex > 0) {
      this.redirectToNextPreviousQuestion(currentIndex - 1);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(currentIndex - 1);
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    const nextIndex = currentIndex + 1;
    if (nextIndex < questionData.length) {
      this.redirectToNextPreviousQuestion(nextIndex);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(nextIndex);
    }
  };

  handleSelect = (type, value) => {
    this.setState({ [type]: value, isError: false });
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { selectedAnswer1, selectedAnswer2, selectedOptions, currentQuestion } = this.state;
    const { apiServices, questionType: type } = this.props;
    const answerValue1 = currentQuestion[selectedAnswer1];
    const answerValue2 = currentQuestion[selectedAnswer2];

    let isCorrect = false;
    let selectedChoice;
    if (type === QUESTION_TYPE.TABLE_QUESTION) {
      const answersKeys = {};
      isCorrect = Object.keys(currentQuestion)
        .filter((key) => key.startsWith('answer'))
        .every((key) => {
          const optionKey = key.replace('answer', 'option');
          return currentQuestion[key] === selectedOptions[optionKey];
        });
      selectedChoice = JSON.stringify(selectedOptions);
      if (Object.keys(selectedOptions).length !== 3) {
        this.setState({ isError: true });
        return;
      }
    } else {
      isCorrect =
        answerValue1 === currentQuestion.answer1 && answerValue2 === currentQuestion.answer2;
      selectedChoice = JSON.stringify({ selectedAnswer1, selectedAnswer2 });
      const isValidated = selectedAnswer1 && selectedAnswer2;
      if (!isValidated) {
        this.setState({ isError: true });
        return;
      }
    }
    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: isCorrect,
      selected_choice: selectedChoice,
      type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      const { stateTableName = 'gmat_focus_question_stat' } = this.props;
      this.setState({
        questionData: this.state.questionData.map((questionDetails) =>
          questionDetails.id === currentQuestion.id
            ? {
                ...questionDetails,
                [stateTableName]: {
                  selected_choice: selectedChoice,
                  isSelectedChoice: isCorrect,
                },
              }
            : questionDetails,
        ),
      });
    }
  };

  renderOptionRows = () => {
    const { validated, currentQuestion } = this.state;

    // Dynamically get all answer keys (e.g., answer1, answer2, etc.)
    const answerKeys = Object.keys(currentQuestion).filter((key) => {
      if (key.startsWith('answer') && Boolean(currentQuestion[key])) return true;
    });

    // Dynamically get selected answer values from state
    const selectedAnswers = answerKeys.reduce((acc, answerKey) => {
      const index = answerKey.replace('answer', '');
      acc[answerKey] = this.state[`selectedAnswer${index}`];
      return acc;
    }, {});
    // Get all option entries
    const optionEntries = Object.entries(currentQuestion).filter(([key]) =>
      key.startsWith('option'),
    );
    return optionEntries.map(([optionKey, optionValue]) => (
      <tr key={optionKey}>
        {/* Render a <td> for each answer (answer1, answer2, ...) */}
        {answerKeys.map((answerKey, idx) => {
          const selectedKey = `selectedAnswer${answerKey.replace('answer', '')}`;
          const isCorrect = currentQuestion[answerKey] === optionValue;
          const isSelected = selectedAnswers[answerKey] === optionKey;
          const inputClass =
            validated && isSelected ? (isCorrect ? 'accent-success' : 'accent-faliure') : '';

          const isShowCorrectChoices = validated && isCorrect && !isSelected;

          return (
            <td className='border-solid-1 p-10px' key={`${optionKey}-${answerKey}`}>
              {isShowCorrectChoices ? (
                <input
                  type='radio'
                  name={`correct${idx + 1}`}
                  className='accent-success'
                  checked
                  readOnly
                />
              ) : (
                <input
                  type='radio'
                  name={`answer${idx + 1}`}
                  className={inputClass}
                  checked={isSelected}
                  disabled={!inputClass && validated}
                  onChange={() => this.handleSelect(selectedKey, optionKey)}
                />
              )}
            </td>
          );
        })}

        {/* Option text */}
        <td className='border-solid-1 p-10px'>{optionValue}</td>
      </tr>
    ));
  };
  handleChoicesSelect = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      selectedOptions: {
        ...prevState.selectedOptions,
        [name]: value,
      },
      isError: false,
    }));
  };
  renderOptionColumns = () => {
    const { validated, currentQuestion, selectedOptions = {} } = this.state;

    // Create entries like { key: "option1", value: "yes" }
    const optionEntries = Object.entries(currentQuestion)
      .filter(([key]) => key.startsWith('option'))
      .map(([key, value]) => ({ key, value }));

    return optionEntries.map((optionValue, index) => {
      const optionKey = optionValue.key; // e.g., "option1"
      const answerKey = optionKey.replace('option', 'answer'); // maps to "answer1"
      const correctAnswer = currentQuestion[answerKey]; // e.g., "yes"

      return (
        <tr key={optionKey}>
          {['yes', 'no'].map((choiceValue) => {
            const isSelectedChoice = selectedOptions[optionKey] === choiceValue;

            // Determine class if validated
            let validationClass = '';
            if (validated && isSelectedChoice) {
              validationClass = choiceValue === correctAnswer ? 'accent-success' : 'accent-faliure';
            }

            return (
              <td
                className={`border-solid-1 p-10px ${validationClass}`}
                key={`${optionKey}-${choiceValue}`}
              >
                <input
                  type='radio'
                  name={optionKey}
                  className='border-solid'
                  checked={isSelectedChoice}
                  value={choiceValue}
                  disabled={!validationClass && validated}
                  onChange={this.handleChoicesSelect}
                />
              </td>
            );
          })}
          <td className='border-solid-1 p-10px'>{optionValue.value}</td>
        </tr>
      );
    });
  };

  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };

  resetTableContent = () => {
    const { currentQuestion } = this.state;
    this.setState(
      {
        questionTable: '',
      },
      () => {
        this.setState({
          questionTable: `<table id="myTable" border="1" cellpadding="5px" ${
            currentQuestion.question.split('<table')
              ? currentQuestion.question.split('<table')[1]
              : currentQuestion.question
          }`,
        });
        document.getElementById('table_data_select').selectedIndex = 0;
      },
    );
  };
  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      questionRating,
      questionRatingTitle,
      showCalculator,
      questionContent,
      questionTable,
      sortingOptions,
      isError,
    } = this.state;
    const { apiServices, params, redirectTo, questionType, examName } = this.props;

    // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
    // snake_case keys that the BE /reportQuestion writer expects.
    const { readingid: reading_id, question_id, type, reading: topic_name } = params;
    const { router } = this.context;
    const { id, question, choice_a, choice_b, explanation } = currentQuestion;
    return (
      <div>
        <ComponentHeader title={messages.QUESTION_BANK}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() =>
                this.setState({
                  showCalculator: true,
                })
              }
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectTo('question')}>
              {messages.CHANGE_QUESTION}
            </CustomButton>
            <CustomButton onClick={() => redirectTo('reading')}>
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          {currentQuestion && Object.keys(currentQuestion).length ? (
            <CustomCard>
              <CustomCardHeader
                headingText={`${topic_name} (Q. ${id})`}
                headerImage={questionBankIcon}
                arrayLength={questionData.length}
                showPreviousButton
                showNextButton
                disabledPreviousButton={currentIndex < 1}
                disabledNextButton={currentIndex >= questionData.length - 1}
                getPreviousQuestion={this.getPreviousQuestion}
                getNextQuestion={this.getNextQuestion}
              />
              <CustomCardBody>
                <Row>
                  <Col xs={12}>
                    {questionType === QUESTION_TYPE.TABLE_QUESTION ? (
                      <div className='card-block font-16px statement-question-div'>
                        {renderHTMLContent(questionContent || question, 'div', 'text-justify')}
                        <TableSort
                          sortOptions={sortingOptions}
                          onSortChange={(value) => onHandleTableSorting(value)}
                          onReset={this.resetTableContent}
                        />
                        {renderHTMLContent(questionTable, 'div', 'overflow-x-auto table-w-100')}
                      </div>
                    ) : (
                      renderHTMLContent(question, 'p', 'font-16px')
                    )}
                    <table className='text-center border-solid-1 margin_bottom_30'>
                      <thead>
                        <tr>
                          <th className='border-solid-1 p-10px'>{choice_a}</th>
                          <th className='border-solid-1 p-10px'>{choice_b}</th>
                          <th className='border-solid-1 p-10px' />
                        </tr>
                      </thead>
                      <tbody>
                        {questionType === QUESTION_TYPE.TABLE_QUESTION
                          ? this.renderOptionColumns()
                          : this.renderOptionRows()}
                      </tbody>
                    </table>
                  </Col>
                </Row>
                <Row>
                  {isError && (
                    <Col sm={12} md={12} lg={12} className='text-danger text-left  mb-0 pb-0'>
                      {messages.SELECT_OPTION_ERROR}
                    </Col>
                  )}
                  <Col xs={6} lg={6} sm={6} className='text-center mt-3 d-flex'>
                    {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
                    <ValidateSaveReportIcon
                      isQue={true}
                      showResult={validated}
                      _getResult={this.handleValidate}
                      _saveQuestion={this.handleSaveQuestion}
                      _displayReportForm={this.reportCardToggle}
                      all_questions={questionData}
                      save_text={saveTooltipTitle}
                      bookmarkCSS={bookmarkCSS}
                      bookmarkColor={bookmarkColor}
                    />
                  </Col>
                  <Col
                    xs={6}
                    lg={6}
                    sm={6}
                    className='text-center mt-3 d-flex align-items-center justify-content-end'
                  >
                    <span className='margin_bottom_0 margin_right_10'>{questionRatingTitle}:</span>
                    <RatingComponent
                      rating={questionRating}
                      onChange={(nextValue, prevValue, name) =>
                        this.handleQuestionRating(currentQuestion, nextValue, prevValue, name)
                      }
                    />
                  </Col>
                </Row>
              </CustomCardBody>
            </CustomCard>
          ) : (
            <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
          )}
        </LoaderWrapper>

        {validated && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                  className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
                />
                <CustomCardBody>{renderHTMLContent(explanation, 'span')}</CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        <FlashCard
          item={{ id: currentQuestion && id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        {/* //TODO: Remove the ! from the common component */}
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/TwoStatement.jsx